import { useClinicPaymentAbilitiesAndCancelPolicyQuery } from "../../../../../../api/queries/useClinicPaymentAbilitiesAndCancelPolicyQuery";

export function useClinics() {
  const {
    data: clinicsData,
    isLoading,
    isSuccess,
  } = useClinicPaymentAbilitiesAndCancelPolicyQuery();

  const clinics = Object.entries(clinicsData?.data?.data?.clinics || {}).map(
    ([id, { name }]) => ({
      id: Number(id),
      clinic_name: name,
    }),
  );

  return {
    data: clinics,
    isLoading,
    isSuccess,
  };
}
